import { SurveyAnswerHeader } from './Header/SurveyAnswerHeader';

import type { RespondentStanding } from '@/pages/SurveyAnswer/FeedbackPrivacy/anonymousRespondentCopy';
import type { User } from '@/types/directory/User';
import type { PropsWithChildren } from 'react';

import {
    isAnonymousFeedback,
    revieweeLaunchedCopy,
    type FeedbackPrivacyValue,
} from '@/constants/review/FeedbackPrivacy';

export type SurveyAnswerFrameProps = PropsWithChildren<{
    reviewee?: User;
    isSelfEvaluation?: boolean;
    feedbackPrivacy?: FeedbackPrivacyValue;
    respondentStanding?: RespondentStanding;
}>;

/** The survey page around its window: who is being answered about, above it. */
export const SurveyAnswerFrame = ({
    reviewee,
    isSelfEvaluation = false,
    feedbackPrivacy,
    respondentStanding,
    children,
}: SurveyAnswerFrameProps) => (
    <section className={'w-full py-10 sm:py-14 md:py-20'}>
        <div className={'mx-auto max-w-6xl px-6 sm:px-8'}>
            <SurveyAnswerHeader
                reviewee={reviewee}
                isSelfEvaluation={isSelfEvaluation}
                isAnonymous={isAnonymousFeedback(feedbackPrivacy)}
                revieweeSees={
                    respondentStanding?.launchedByReviewee
                        ? revieweeLaunchedCopy(feedbackPrivacy)
                        : undefined
                }
            />

            {children}
        </div>
    </section>
);
